import React from 'react';
import ReactDOM from 'react-dom';
import VehicleTitle from './VehicleTitle';
import propDefs from '../proptypes';
import { remapPrefs } from '../utils/utility';

export default class VehicleTitleSidebar extends React.Component {
	constructor(props) {
		super(props);
		this.el = document.createElement('div');
	}

	componentDidMount() {
		const [container, ..._otherContainers] = document.querySelectorAll(
			'.ddc-vehicle-title-sidebar'
		);
		this.containerEl = container;

		if (this.containerEl) {
			this.containerEl.appendChild(this.el);
		}
	}

	componentWillUnmount() {
		if (this.containerEl) {
			this.containerEl.removeChild(this.el);
		}
	}

	render() {
		const sidebarPrefs = remapPrefs(this.props.prefs, '-sidebar');
		// Use a portal to render vehicle info text into the sidebar
		return ReactDOM.createPortal(
			<VehicleTitle
				vehicle={this.props.vehicle}
				deviceType={this.props.deviceType}
				prefs={sidebarPrefs}
				labels={this.props.labels}
			/>,
			this.el
		);
	}
}

VehicleTitleSidebar.propTypes = {
	vehicle: propDefs.settings.vehicle,
	deviceType: propDefs.settings.deviceType.isRequired,
	prefs: propDefs.settings.prefs.isRequired,
	labels: propDefs.labels.isRequired
};

VehicleTitleSidebar.defaultProps = {
	vehicle: propDefs.defaults.vehicle
};



// WEBPACK FOOTER //
// ./src/components/VehicleTitleSidebar.jsx